export default __webpack_public_path__ + "static/media/comment.72e79c54.svg";